<template>
  <v-container>
    <bookshelf-items />
    <bookshelf-book-lists />
  </v-container>
</template>

<script>
import BookshelfItems from "@/components/BookshelfItems";
import BookshelfBookLists from "@/components/BookshelfBookLists";

export default {
  name: "BookshelfUser",
  metaInfo() {
    return {
      title: this.$t('routes.bookshelf'),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.$t('seo.bookshelfDescription'),
        },
      ],
    }
  },
  components: {
    BookshelfItems,
    BookshelfBookLists,
  },
};
</script>
